export default __webpack_public_path__ + "static/media/homeButton.16b0edd2.png";